// Put everything in an IIFE so as not to pollute the global namespace
(function(){
  /* ========= BEGIN UTILITIES ========= */

  var DR_allowedCountries = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
].map(function(cc){
  return cc.toLowerCase()
});
  

var DR_allowedLocales = ["en"];

var DR_USER_COUNTRY_LOCAL_STORAGE_KEY = "DR_USER_COUNTRY";

var US_COUNTRY_CODE = 'us';
var CA_COUNTRY_CODE = 'ca';
var isUSOrCA = function(country_code){
  return country_code == US_COUNTRY_CODE || country_code == CA_COUNTRY_CODE
} 

var DR_ENABLE_DEBUG_LOGS = true; 

var DR_DEBUG_LOG = function(){
  if(DR_ENABLE_DEBUG_LOGS){
      console.log.apply(console, arguments);
  }
}

var HIDE_FOOTER = false;
// Local storage workflow taken from here
// It is very straightforward
// https://www.sohamkamani.com/javascript/localstorage-with-ttl-expiry/
function setWithExpiryFromLocalStorage(key, value, ttl) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
  DR_DEBUG_LOG("Item to be set in localstorage with expiry", item)
	localStorage.setItem(key, JSON.stringify(item))
}
function getWithExpiryFromLocalStorage(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
    DR_DEBUG_LOG("DEBUG: Local storage item was expired", key)
		localStorage.removeItem(key)
		return null
	}
  DR_DEBUG_LOG("DEBUG: Local storage item was not stale, returning", key)
	return item.value
}

function minutesToMilliseconds(minutes){
  return minutes * 60 * 1000
}

/* ========= END UTILITIES ========= */

function normalizeJoinedPath(path){
  if(path[0] !== "/"){
    return "/" + path;
  }
  return path;
}
function constructRedirectUrl(shopifyPathInfo, redirectToUS, country, locale = "en", ){
  var url;
  // Defaults to "US"
  if(redirectToUS){
    url = shopifyPathInfo.requestOrigin + normalizeJoinedPath(shopifyPathInfo.joinedPath) + shopifyPathInfo.searchParams;
  } else {
    var localeAndCountryCode = locale + "-" + country.toLowerCase();
    url = shopifyPathInfo.requestOrigin + "/" + localeAndCountryCode + normalizeJoinedPath(shopifyPathInfo.joinedPath) + shopifyPathInfo.searchParams;
  }
  return url
}

function getRedirectUrl(shopifyPathInfo, country){
  var ipFromUS = country == US_COUNTRY_CODE

  // This is the case where we have received a locale and country code in the shopify path
  // Right now this will not occur if it is the US site as those paths are not prefixed with en-us
  if (shopifyPathInfo.hasValidLocale && shopifyPathInfo.hasValidCountry) {
    
    var ipCountryAndCountryInPathMatch = country.toLowerCase() == shopifyPathInfo.potentialCountryCode.toLowerCase();
    
    DR_DEBUG_LOG("DEBUG: We are not trying to access a US site")
    DR_DEBUG_LOG("DEBUG: The IP Service Stated the country is:", country)
    DR_DEBUG_LOG("DEBUG: The country code in the shopify path is", shopifyPathInfo.potentialCountryCode)
    DR_DEBUG_LOG("DEBUG: Do they match?", ipCountryAndCountryInPathMatch)
    
    if (ipCountryAndCountryInPathMatch) {
      DR_DEBUG_LOG("DEBUG: We found the path to be consistent with the country, doing no redirect")
      return null;
    } else {
      DR_DEBUG_LOG("DEBUG: We found the path to be inconsistent with the ip resolved country")
      DR_DEBUG_LOG("DEBUG: Redirecting to ip resolved country:", country)
      if (ipFromUS) {
        // This case FORCES US users AWAY from International routes
        var url = constructRedirectUrl(shopifyPathInfo, true, country);
        return url
      } else {
        // var url = constructRedirectUrl(shopifyPathInfo, false, country)
        // return url
        return null;
      }
    }
  } 
  // No country code in URL - and IP is detected to be US or Non-US, we don't want to route in this case. (INT Users && US can browse US)
  else if (shopifyPathInfo.potentiallyUS && ipFromUS || shopifyPathInfo.potentiallyUS && !ipFromUS) {
    //If IP says US and no locale-country pair resolve to US) --> Do nothing!
    DR_DEBUG_LOG("DEBUG: The IP Service Stated the country is:", country, "and shopify path is correct. Doing Nothing")
    return null;
  }
  // There may be unhandled cases, let the dev know just in case
  else {
    throw new Error("We got an unhandled case, investigate!!");
  }
}

function getCurrentShopifyPathInfo(requestOrigin, requestPath, searchParams) {
  // Split out the url params
  var splitPath = requestPath.split("/");
  // Parse out the first part of the path
  var localeCountryUrlPathPartial = splitPath[1] ? splitPath[1] : "";
  // Keep track of the rest: 
  // In the US Case we will use the whole path because there is no locale/country combo
  // but in case we need to redirect 
  // e.g. from en-in to en-pk we will need the non country code path partial
  // Same for us --> non US
  var restOfPath = splitPath.length > 1 ? splitPath.slice(2) : [""];
  var joinedPath = restOfPath.join("/");
  var localeAndCountryCodeCandidate = localeCountryUrlPathPartial.split("-");
  var potentialLocale = localeAndCountryCodeCandidate[0] ? localeAndCountryCodeCandidate[0] : "";
  var potentialCountryCode = localeAndCountryCodeCandidate[1] ? localeAndCountryCodeCandidate[1] : "";
  // We need to keep track of allowed countries because the US site is the NEGATIVE case
  // i.e. when there is no country present. This is a bit tedious but we can't think of another way.
  var hasValidLocale = DR_allowedLocales.indexOf(potentialLocale) > -1
  var hasValidCountry = DR_allowedCountries.indexOf(potentialCountryCode) > -1
  var hasValidCountryAndLocale = hasValidCountry && hasValidLocale;
  var potentiallyUS = !hasValidCountry && !hasValidLocale;
  // Return all of the information for future use by the redirector function
  var result = {
      localeCountryUrlPathPartial : hasValidCountryAndLocale ? localeCountryUrlPathPartial : "",
      potentialLocale             : hasValidLocale ? potentialLocale : "",
      potentialCountryCode        : hasValidCountry ? potentialCountryCode : "",
      searchParams                : searchParams,
      requestOrigin               : requestOrigin,
      requestPath                 : requestPath,
      hasValidLocale              : hasValidLocale,
      hasValidCountry             : hasValidCountry,
      potentiallyUS               : potentiallyUS,
      joinedPath                  : potentiallyUS ? requestPath : joinedPath,
  };
  DR_DEBUG_LOG("DEBUG: shopifyPathInfo : ", JSON.stringify(result));
  return result;

}

function showHideFooter (countryFromIPRegion) {
  DR_DEBUG_LOG("DEBUG: Hit the potentially US case", countryFromIPRegion)
  if(countryFromIPRegion == 'us'){
    DR_DEBUG_LOG("DEBUG: Hiding the footer");
    HIDE_FOOTER = true;
  } else {
    DR_DEBUG_LOG("DEBUG: Not hiding the footer");
    HIDE_FOOTER = false;
  }
}

function redirectBehaviors(response) {
  try {
    
    // !!!! OVERRIDE FOR TESTING - set to 2 letter country code to test another region
    //response.country = "mx"
    // END TESTING OVERRIDE
    DR_DEBUG_LOG("DEBUG: Running Redirect behaviors")
    DR_DEBUG_LOG("DEBUG: IP Info", JSON.stringify(response));
    DR_DEBUG_LOG("DEBUG: country from IP Service:", response['country'])
    var countryFromIPRegion = response.country.toLowerCase();

    DR_DEBUG_LOG("DEBUG: Setting users country in local storage:", countryFromIPRegion)
    setWithExpiryFromLocalStorage(DR_USER_COUNTRY_LOCAL_STORAGE_KEY, countryFromIPRegion, minutesToMilliseconds(1));

    var shopifyPathInfo = getCurrentShopifyPathInfo(
      window.location.origin,
      window.location.pathname,
      window.location.search
    );
    var redirectUrl = getRedirectUrl(shopifyPathInfo, countryFromIPRegion);
    DR_DEBUG_LOG("DEBUG: Redirecting to:", redirectUrl);
    if(redirectUrl){
      window.location.href = redirectUrl;
    } 
    showHideFooter(countryFromIPRegion)
  } catch (e) {
    DR_DEBUG_LOG("Error while getting redirect behavior", e)
  }
}

function runRedirectBehaviors(){
  window.jQuery.get('https://ipinfo.io/json', redirectBehaviors, "jsonp")
}
function nonDRCheckIfShouldRedirectToGap(){
  window.jQuery.get('https://ipinfo.io/json', checkIfUSAndRedirectToGap, "jsonp")
}
function checkIfUSAndRedirectToGap(response){
  // OVERRIDE FOR TESTING
  // response.country = "MX";
  var countryFromIPRegion = response.country.toLowerCase();
  if(countryFromIPRegion === US_COUNTRY_CODE){
    DR_DEBUG_LOG("DEBUG: DR is Disabled and user from US, should redirect to Gap.com main website");
    window.location.href = "https://www.gap.com/";
  } else {
    // DR DISABLED
    // INTERNATIONAL USER
    // we want to keep the international site untouched
    // DR_DEBUG_LOG("DEBUG: Determined it was not US, run gap checks");
    // // Enable if we want redirects in the international site
    // redirectBehaviors(response);
  }
}
function runCheckWhetherLoginShouldBeBlocked(){
  window.jQuery.get('https://ipinfo.io/json', checkIfUSAndBlockLogin, "jsonp")
}
function checkIfSlashAccountInURL(shopifyPathInfo){
  var requestPath = shopifyPathInfo.requestPath;
  return requestPath.indexOf("/account") !== -1;
}
function checkIfUSAndBlockLogin(response){
  // OVERRIDE FOR TESTING
  // response.country = "MX";
  var shopifyPathInfo = getCurrentShopifyPathInfo(
    window.location.origin,
    window.location.pathname,
    window.location.search
    );
    
    var countryFromIPRegion = response.country.toLowerCase();
    var containsMyAccountInUrl = checkIfSlashAccountInURL(shopifyPathInfo);
    var userFromUSorCA = isUSOrCA(countryFromIPRegion);
    // We want to redirect if US user is in the account path space
    if(userFromUSorCA && containsMyAccountInUrl){
      DR_DEBUG_LOG("DEBUG: DR is Disabled and user from US, should redirect to Gap.com main website");
      window.location.href = shopifyPathInfo.requestOrigin;
    }
    // If we're not redirecting, then check if the my-account link is at the top nav and remove if so 
    else if (userFromUSorCA) {
      $('.site-header-actions__account-link').remove();
      //$('#customer-service-for-intl').remove();
    }
}
function checkLocalStorageForMatchingPathAndRunRedirectLogicIfNonexsistent(){
  DR_DEBUG_LOG("DEBUG: DR is enabled, performing redirect behaviors");

  var countryInLocalStorage = getWithExpiryFromLocalStorage(DR_USER_COUNTRY_LOCAL_STORAGE_KEY)
  DR_DEBUG_LOG("DEBUG: Found Users Country in Local Storage", countryInLocalStorage)

  var shopifyPathInfo = getCurrentShopifyPathInfo(
    window.location.origin,
    window.location.pathname,
    window.location.search
  );
  /*
    DR Scenario: When testing local storage we should run the following manual test cases:
    1) Local storage is empty (or expired):
      - Expected Result: Should set correct country value based on IP
      - Tests:
        - User from US, with nothing in localstorage tries to go to /      : ✓ No Redirect
        - User from ES, with nothing in localstorage tries to go to /en-es : ✓ No Redirect 
        - User from US, with nothing in localstorage tries to go to /en-es : ✓ Redirect and set local storage to us

    2) Local storage has a country value which matches the path:
      - Expected Result: Do nothing.
      - Tests:
        - User from US, with us in localstorage tries to go to /      : ✓ No Redirect
        - User from ES, with es in localstorage tries to go to /en-es : ✓ No Redirect 

    3) Local storage has a country value which does not match the shopify path:
      - Expected Result: Should redirect to appropriate shopify path
      - Tests:
        - User from US, with us in localstorage tries to go to /en-es : ✓ redirects to 
        - User from ES, with es in localstorage tries to go to /en-pk : ✓ No Redirect

    4) Local Storage has a bunk country code:
      - Expected Result: Run logic to get the country from IP and redirect appropriately.
      - Tested?:
        - User from US, with ES in local tries to go to ES with nonsense in local storage: 
          - ✓ (ends up base domain route w/ us in local storage)
        - User from ES, tries to go to US with nonsense in local storage: 
          ✓ (ends up at /en-es with es in local storage )

    5) Test that an expired local storage item does NOT redirect the user if they are still in the same country. 
      - Expected Result: User not redirected extraneously
      - Tested?: ✓ (Note: TTL is currently set at 1 minute for easy testing), 
       - Made sure local storage was expired, no redirect happened for appropriate country
  */
  var hasValidCountryInLocalStorage = DR_allowedCountries.indexOf(countryInLocalStorage) > -1;

  if(!hasValidCountryInLocalStorage){
    DR_DEBUG_LOG("DEBUG: Invalid country, found:", countryInLocalStorage, " resolving IP and redirecting");
    runRedirectBehaviors();
    return;
  }
  if( countryInLocalStorage ){
    // If local storage and the URL says US then dont run redirect behaviors
    if(shopifyPathInfo.potentiallyUS && countryInLocalStorage === US_COUNTRY_CODE){
      DR_DEBUG_LOG("DEBUG: Shopify path is for the US and local storage agrees, not running redirect behaviors");
      DR_DEBUG_LOG("DEBUG: Hiding the footer");
      HIDE_FOOTER = true;
      return;
    }
    // In this case the shopify path info agrees
    else if(shopifyPathInfo.potentialCountryCode === countryInLocalStorage){
      DR_DEBUG_LOG(
        "DEBUG: Local storage thinks the user is in",
        countryInLocalStorage, 
        "and they are trying to access the shopify path for country: ",
        shopifyPathInfo.potentialCountryCode,
        " -- not running redirect behaviors");
      return;
    }
    // In this case we got a mismatch on the shopify path and the local storage value 
    else { 
      DR_DEBUG_LOG(
        "DEBUG: Local storage said the country was", countryInLocalStorage,
        "But we think the path shows: ", shopifyPathInfo.potentialCountryCode, "running redirects");
        runRedirectBehaviors();
        return;
    }
  }
  // We have nothing in local storage, run the full logic 
  else {
    runRedirectBehaviors();
    return;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  /**
   * Delete footer locale -- this has to be polled because the footer loads asynchronously
   * Otherwise there's no method of knowing when the footer exists
   * The method was modified from sdg-global.js.liquid's code to move the footer
   */
  function deleteFooterLocale() {
    // Check for locale selector and remove if HIDE_FOOTER is true
    var checkElementExists = setInterval(function() {
      var $localeSelectorContainer = document.getElementById('GAP_INT_COUNTRY_SELECTOR');
      // HIDE_FOOTER is set when the locale is US in the redirect logic
      if ($localeSelectorContainer && HIDE_FOOTER == true) {
        clearInterval(checkElementExists);
        $('#GAP_INT_COUNTRY_SELECTOR').first().parent().remove();
      }
    }, 200);

    // Clear timeout after 10 seconds if the locale selector doesn't show up
    setTimeout(function() {
      if (checkElementExists) {
        clearInterval(checkElementExists);
      }
    }, 10000);
  }

  deleteFooterLocale();
});

function checkIfDRIsEnabledAndCheckCountryOfOrigin(){
  // This flag is set within the theme settings
  // We use the string to boolean conversion in case raw  might cause JS to parse incorrectly
  var _DR_ENABLED = 'false';
  var DR_ENABLED = _DR_ENABLED == 'true';
  var DR_DISABLED = !DR_ENABLED;
  DR_DEBUG_LOG("DEBUG: IS DR_ENABLED? : ", DR_ENABLED)
  // No matter what US/CA users are not allowed to see account pages
  runCheckWhetherLoginShouldBeBlocked()
  if(DR_DISABLED){
    DR_DEBUG_LOG("DEBUG: DR is not enabled, not redirecting");
    localStorage.removeItem(DR_USER_COUNTRY_LOCAL_STORAGE_KEY);
  } else {
    // DR IS ENABLED
    checkLocalStorageForMatchingPathAndRunRedirectLogicIfNonexsistent();
  }
};
checkIfDRIsEnabledAndCheckCountryOfOrigin();


})()
